import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth';
import { OnboardingComponent } from './components/onboarding';
import { WelcomeComponent } from './components/welcome';
import { SuperSmartComponent } from './components/super-smart';

const routes: Routes = [
  {
    path: 'onboarding',
    component: OnboardingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'onboarding/bem-vindo',
    component: WelcomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'onboarding/super-smart',
    component: SuperSmartComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnboardingRoutingModule {}
